<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("politica-comercial") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t("b2b") }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({
                                                name: 'b2b-politica-comercial-list',
                                            })"
                                    >{{ $t("politica-comercial") }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ `${$route.params.id} - ${loadingName ? $t("carregando") : name}` }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToPage()"
                        >
                            {{ $t("voltar") }}
                        </button>
                    </div>
                </div>

                <ul class="nav nav-tabs nav-tabs-main">
                    <router-link
                        tag="li"
                        :to="{
                            name: 'b2b-politica-comercial-geral',
                            params: { id: $route.params.id },
                        }"
                    >
                        <a>{{ $t("geral") }}</a>
                    </router-link>

                    <router-link
                        v-if="permissaoPoliticaComercial.read"
                        tag="li"
                        :to="{
                            name: 'b2b-politica-comercial-relacao-com-cliente',
                            params: { id: $route.params.id },
                        }"
                    >
                        <a>{{ $t("relacao-com-cliente") }}</a>
                    </router-link>
                </ul>
                
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

// Abas
import Geral from "@/components/b2b/politica-comercial/abas/Geral";
import RelacaoComCliente from '@/components/b2b/politica-comercial/abas/RelacaoComCliente';
import B2BEmpresaService from '@/services/b2b/B2BEmpresaService';

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        Geral,
        RelacaoComCliente
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            abas: [
                "geral",
                "relacao-com-cliente"
            ],
            abasAbertas: {},
            permissaoDadosCadastrais: false,
            permissaoPoliticaComercial: false,
            listaPermissoes: {},
            isChanged: false,
            service: new B2BEmpresaService(this.$http, this.$router),
            name: null,
            loadingName: false
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
        if (this.$route.query.dadoscadastrais && this.$route.params.id) {
            this.changeTab(this.$route.query.dadoscadastrais < this.abas.length 
                ? this.$route.query.dadoscadastrais
                : 0
            );
        }
    },
    created() {
        this.permissaoDadosCadastrais = this.hasPermissionAccess(
            "b2b",
            "b2b-politica-comercial-list"
        );

        if (
            !this.permissaoDadosCadastrais.create ||
            !this.permissaoDadosCadastrais.read
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "b2b" },
            });
        } else {
            this.loadName();
            // Criação dinâmica de listaPermissoes e abasAbertas baseado no nome das tabs
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    "b2b",
                    `b2b-politica-comercial-list-${value}`
                );
            }

            this.permissaoPoliticaComercial = this.hasPermissionAccess(
                "b2b",
                "b2b-politica-comercial-edit"
            );

            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }
            this.id = this.$route.params.id;
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        loadName() {
            this.loadingName = true;
            this.service.find(this.$route.params.id)
                .then((res) => {
                    this.name = res.content.rsocial;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.loadingName = false;
                })
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        redirectToPage() {
            this.$router.push({
                name: 'b2b-politica-comercial-list'
            });
        }
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .nav-tabs-main {
            margin-bottom: 10px;
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}
</style>
